<template lang="pug">
    .card-teaser(v-if="display === 'card'" :class="{ hover: mouseover }")
        router-link(
            :to="path"
            @mouseover.native="hover"
            @mouseleave.native="blur"
        )
            figure
                img.is-rounded(v-if="showImage" v-lazy="image" :title="title" )
        h3.is-size-5(v-if="title")
            | {{ title }} 
        .bait(v-if="text && category === 'mitglieder'")
            p.content(v-html="striptags(text)")
        .bait(v-else-if="text" v-line-clamp:24="3")
            p.content(v-html="striptags(text)")
        .link
            router-link(:to="path") [MEHR]
    .row-teaser(v-else :class="{ hover: mouseover }")
        .columns.is-multiline
            .image.column.is-5
                router-link(
                    :to="path"
                    @mouseover.native="hover"
                    @mouseleave.native="blur"
                )
                    figure.mitglieder(v-if="category === 'mitglieder'")
                        img(v-if="showImage" v-lazy="image" :title="title" )
                    figure(v-else-if="category != 'mitglieder'") 
                        img(v-if="showImage" v-lazy="image" :title="title" )       
            .text.column.is-7
                router-link(
                    :to="path"
                    @mouseover.native="hover"
                    @mouseleave.native="blur"
                )
                    h3.is-size-5(v-if="title")
                        | {{ title }}
                .bait(v-if="text && category === 'mitglieder'")
                    p.content(v-html="text")
                .bait(v-else-if="text" v-line-clamp:24="3")
                    p.content(v-html="striptags(text)")
                    .link
                        router-link(:to="path") [MEHR]

</template>

<script>

import _ from 'lodash'
import striptags from 'striptags'
// import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Teaser',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
        }
    },
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        display: {
            type: String,
            default: 'row',
        },
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {

            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height
            let aspectRatio = 1 / 1

            width = 320
            height = width / aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        path() {
            const categoryKey = _.get(this.teaser, 'category.key')
            const key = this.teaser.key

            let categoryPath
            switch (categoryKey) {
                case 'news':
                    categoryPath = `/aktuelles/${key}`
                    break;

                case 'homepage':
                    categoryPath = `/homepage/${key}`
                    break;

                case 'mitglieder':
                    categoryPath = `/mitglieder/${key}`
                    break;
                    
                case 'infomitglieder':
                    categoryPath = `/infomitglieder/${key}`
                    break;
                case 'archiv':
                    categoryPath = `/archiv/${key}`
                    break;      
            }

            return categoryPath
        },
        topic() {
            return _.get(this.teaser, 'category.name')
        },
        category() {
            return _.get(this.teaser, 'category.key')
        },
        catLayout() {
            let orientation = 'vertical';
            if (!this.settings) return orientation;
            const layout = this.settings.find(setting => setting.key === 'cat_layout');
            if (layout) {
                orientation = layout.value;
            }
            return orientation;
        },
        title() {
            return _.get(this.teaser, 'title')
        },
        text() {
            let content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }

            if (! (content && content.text) && this.postSection) {
                content = this.postSection.contents.find(content => content.key === 'content')
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return content.text
        },
        sections() {
            return this.teaser.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .card-teaser, .row-teaser
        text-align: initial
        h3
            line-height: 1.2
            color: $abagreen
            font-weight: 600
            margin-bottom: 10px
        p.topic
            font-size: .85rem
            margin-bottom: 10px
        .bait
            margin-bottom: 10px
            word-break: normal !important
            br + br
                display: none
        .link a:hover
            color: $abagreen

        figure.mitglieder
            border-radius: 8px
            img
                border-radius: 8px

            
        figure
            position: relative
            width: 100%
            padding-bottom: 100% // 9 / 16
            display: block
            background: #D8D8D8
            border-radius: 50%
            margin-bottom: 20px
            transition: transform .8s ease
            img
                border-radius: 50% 
                position: absolute
                width: 100%
                max-height: 100%
                left: 0
                top: 0
                //box-shadow: $box-shadow-2
                transition: box-shadow .8s ease
        &.hover
            a figure
                transform: scale(1.04)
                img
                    box-shadow: $box-shadow-3

</style>
